const WindowTitleToEventName = {
  set(name) {
    const decoded = $("<textarea/>")
      .html(name)
      .val()
    return (window.document.title = decoded)
  }
}

export default WindowTitleToEventName
